// extracted by mini-css-extract-plugin
export default {"tagBox":"subjectTag_tagBox__iZG87"};